import AppAlert from '@/components/App/AppAlert.vue'

const Alert = {
  install(Vue) {
    this.EventBus = new Vue()
    Vue.component('app-alert', AppAlert)
    Vue.prototype.$alert = {
      show(params) {
        Alert.EventBus.$emit('show', params)
      }
    }
  }
}

export default Alert